import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export const ssoCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(environment.API_BASE)) {
    req = req.clone({
      withCredentials: true,
    });
  }
  return next(req);
};
